/**
 * Template types
 */
export default class FormatTemplateType
{
	// Default template
	static DEFAULT = 'DEFAULT';

	// Template for autocomplete
	static AUTOCOMPLETE = 'AUTOCOMPLETE';

	// Template for field ADDRESS_LINE_1
	static ADDRESS_LINE_1 = 'ADDRESS_LINE_1';
}